import {
    ListBase,
    ListProps,
    useQuery,
    Loading,
    Error,
    useTranslate,
    Title,
    downloadCSV,
} from 'react-admin';
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import jsonExport from 'jsonexport/dist';
import { format } from 'date-fns'

import { ReactElement } from 'react';

import MerchantDashboardAside from './DashboardAside';
import ListChartView from './TransactionList';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 'auto',
        maxWidth: '100vw',
        [theme.breakpoints.up('lg')]: {
            maxWidth: '70vw',
        }
    },
    listView: {
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '7rem',
            paddingRight: '7rem',
        }
    },
    cardTitle: {
        marginTop: '1rem',
        marginBottom: '0.5rem',
    },
    boxChart: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        // paddingRight: '2rem',
    },
}));

const DashboardPage = (props: ListProps) => {
    const classes = useStyles({});
    const translate = useTranslate()

    const { data: merchant, loading, error } = useQuery({
        type: 'getOne',
        resource: 'Merchant',
        payload: {} as any
    })

    if (loading) return <Loading />;
    if (error) return <Error error={error} />;

    const financing = merchant?.Financings[0]
    const repaymentRate = (financing?.repayment_rate / 10000) || 1

    return <Grid container className={classes.root}>
        <Title title={"Pagos"} />

        <Grid item xs={12} sm={5} md={4} style={{ position: 'relative' }}>
            <MerchantDashboardAside merchant={merchant} {...props} />
        </Grid>
        <Grid item xs={12} sm={7} md={8}>
            <Box className={classes.boxChart}>
                <Typography component="h2" variant="h4" className={classes.cardTitle}>{translate("resources.Merchant.dashboard.salesTitle")}:</Typography>
                <TransactionsList repaymentRate={repaymentRate} financingId={financing.id} {...props} />
            </Box>
        </Grid>
    </Grid>
}

interface TransactionsListProps extends ListProps {
    repaymentRate: number;
    financingId?: number;
}

const TransactionsList = (props: TransactionsListProps): ReactElement => {
    const classes = useStyles({});

    const { repaymentRate, financingId } = props

    const exporter = (transactions: any[]) => {
        const transactionsForExport = transactions.map((t: any) => {
            // const { backlinks, author, ...transactionForExport } = t; // omit backlinks and author
            // transactionForExport.author_name = post.author.name; // add a field

            const { timestamp, value, transfer_to_merchant } = t
            // const gross_sale = value / repaymentRate
            const gross_sales = t.collections.aggregate.sum.gross_sales


            return {
                timestamp,
                gross_sales: gross_sales / 100,
                value: value / 100,
                transfer_to_merchant: transfer_to_merchant / 100,
            }
        });
        jsonExport(transactionsForExport, {
            // headers: ['id', 'title', 'author_name', 'body'] // order fields in the export
        }, (err, csv) => {
            downloadCSV(csv, 'payments-' + format(new Date(), "YYMMDD-HHmmss")); // download as 'posts.csv` file
        });
    };


    return (
        <ListBase
            {...props}
            filterDefaultValues={{
                type: ['REPAYMENT', 'DIRECT_PAYMENT']
            }}
            filter={{
                ...(financingId && { 'financing_id': financingId })
            }}
            sort={{ field: 'timestamp', order: 'DESC' }}
            perPage={10}
            bulkActionButtons={false}
            className={classes.listView}
            exporter={exporter}
        >
            <ListChartView repaymentRate={repaymentRate} />
        </ListBase>
    );
};

export default DashboardPage;
